<owc-card class="one-card-flat" style="position:relative">
  <div class="recipient-table-wrap">
    <div class="scrollable-table">
      <owc-table class="cn-recepients-table">

        <owc-table-header sticky style="z-index:1 ; border-bottom: none !important; box-shadow: none !important;">
          <owc-table-header-cell> <owc-checkbox (change)="masterToggle()" [checked]="isAllPageSelected()"
              [indeterminate]="selectedRows.length > 0 && !isAllPageSelected()"></owc-checkbox></owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerId', $event.detail)">Account ID</owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerName', $event.detail)">Account name</owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerContactName', $event.detail)">Account contact name</owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('customerEmail', $event.detail)">Account contact email</owc-table-header-cell>
          <owc-table-header-cell sortable [align]="'left'" (sortOrderChange)="OnSort('sourceName', $event.detail)">Source</owc-table-header-cell>
          <owc-table-header-cell></owc-table-header-cell>
          <owc-table-header-cell></owc-table-header-cell>
          <owc-table-header-cell></owc-table-header-cell>
          <owc-table-header-cell></owc-table-header-cell>
        </owc-table-header>

        <owc-table-body>
          @for (element of pagedData; track $index) {

          <owc-table-row locked>

            <owc-table-simple-cell>
              <div class="truncate-text">
                <owc-checkbox (change)="toggleSelection(element)" (click)="$event.stopPropagation()"
                  [checked]="isSelected(element)" [disabled]="element.disabled"></owc-checkbox>
              </div>
            </owc-table-simple-cell>
            <owc-table-simple-cell [title]="element.customerId">
              <div class="truncate-text">
                {{element.customerId}}
              </div>
            </owc-table-simple-cell>

            <owc-table-simple-cell [title]="element.customerName">
              <div class="truncate-text">
                {{element.customerName}}
              </div>
            </owc-table-simple-cell>
            <owc-table-simple-cell [title]="element.customerContactName">
              <div class="truncate-text">
                {{element.customerContactName}}
              </div>
            </owc-table-simple-cell>

            <owc-table-simple-cell [title]="element.customerEmail">
              <div class="truncate-text">
                {{element.customerEmail}}
              </div>
            </owc-table-simple-cell>

            <owc-table-simple-cell [title]="element.sourceName">
              <div class="truncate-text">

                {{element.sourceName}}
              </div>
            </owc-table-simple-cell>
            <!-- Arrow and click -->
      
              <owc-table-simple-cell (click)="expandToggle(element)"
                [ngStyle]="{'pointer-events': isDuplicated(dataSource, element) || isEmpty(element) ? 'all' : 'none'}">

                <div *ngIf="isDuplicated(dataSource, element) || isEmpty(element)" class="icon-div">
                  <div title="Duplicate recipient warning" style="height: 24px;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px;">
                      <path fill="#D0342C"
                        d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z">
                      </path>
                    </svg>
                  </div>

                  <!-- Toggle Arrows -->
                  <div *ngIf="element == expandedElement">
                    <i class="one-icons-outlined"> chevron_up </i>
                  </div>
                  <div *ngIf="element != expandedElement">
                    <i class="one-icons-outlined"> chevron_down </i>
                  </div>
                </div>
              </owc-table-simple-cell>
           

          </owc-table-row>
          
          <!-- Error Message Row -->
          <owc-table-row *ngIf="(isDuplicated(dataSource, element) || isEmpty(element)) && element == expandedElement" class="error-row">
            <owc-table-simple-cell colspan="8">
              <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
                class="one-element-detail">
                <span *ngIf="isDuplicatedEmail(dataSource, element)">Duplicated contact email for the same Account ID.</span>
                <span *ngIf="isDuplicatedName(dataSource, element)">Different Account name for existing Account ID.</span>
                <span *ngIf="isEmpty(element)">Fields cannot be empty or blank.</span>
              </div>
            </owc-table-simple-cell>
          </owc-table-row>

          }
        </owc-table-body>
      </owc-table>
      
      <!-- Simple Pagination -->
      <div class="simple-pagination">
        <div class="pagination-left">
          <span class="items-per-page-label">Items per page:</span>
          <select 
            class="page-size-dropdown"
            [value]="pageSize" 
            (change)="onPageSizeChange($event)">
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }}
            </option>
          </select>
        </div>
        
        <div class="pagination-center">
          <span class="pagination-info">{{ startIndex }} - {{ endIndex }} of {{ totalCount }}</span>
        </div>
        
        <div class="pagination-right">
          <button 
            class="nav-button" 
            [disabled]="currentPage === 0"
            (click)="goToPreviousPage()"
            title="Previous page">
            &#8249;
          </button>
          <button 
            class="nav-button" 
            [disabled]="currentPage >= totalPages - 1"
            (click)="goToNextPage()"
            title="Next page">
            &#8250;
          </button>
        </div>
      </div>
    </div>
       
    <owc-component-footer>
      <owc-button [disabled]="isDeleteBtnDisabled" (click)="openDeleteConfirmDialog()" style="float:left">Delete from recipients
        list</owc-button>
      <owc-modal-dialog size="small" [(ngModel)]="deleteImport">

        <owc-component-header slot="header">Delete Recipient</owc-component-header>
        <div>
          <owc-typography variant="body2" style="margin: 0 17px 10px;font-size: 17px;">Are you sure, you want to delete this recipient from recipients
            list?</owc-typography>
        </div>
        <owc-component-footer slot="footer"style="align-items:center;justify-content: flex-end;">
          <div class="footer-actions">
            <owc-button class="btn secondary" (click)="closeDeleteModal()">Cancel</owc-button>
            <owc-button mat-stroked-button one-secondary-button (click)="confirmDelete()">Yes, delete</owc-button>
          </div>
        </owc-component-footer>
      </owc-modal-dialog>

      <div class="import-dropdown-button">
        <div *ngIf="isImportBtnExpanded" class="btn-list">
          <owc-button class="sub-btns" (click)="openDialog()">From file</owc-button>
          <hr>
          <owc-button class="sub-btns" (click)="fromRexisSap()">From Rexis/SAP</owc-button>
        </div>
        <owc-button class="btn-import" (click)="btnImportClicked()" [class.btn-expanded]="isImportBtnExpanded">
          <span>Import recipient list</span>
        </owc-button>
      </div>
      <ng-container *ngIf="openFromFile">
      <owc-modal-dialog size="medium" [(ngModel)]="openFromFile">
        <dl-import-dialog-file size="large" [inputData]="inputData"
          (dialogClose)="handleDialogClose($event)"></dl-import-dialog-file>

      </owc-modal-dialog>
    </ng-container>
      <owc-modal-dialog size="large" [(ngModel)]="fromRexisap">
        <ng-container *ngIf="fromRexisap">
        <dl-rexis-sap-dialog (dialogClose)="handleRexisDialogClose($event)"></dl-rexis-sap-dialog>
      </ng-container>
      </owc-modal-dialog>
    
    </owc-component-footer>
  </div>
</owc-card>

<ng-template #myTemplate>
  <div class="emptyRecipientAlertDialog">
    <b>Recipient list upload is not possible.</b>
    <p>For the following recipients the email address is missing. Please correct the data and upload it again.</p>
    <table cellpadding="6px">
      <thead>
        <th>Row Index</th>
        <th>Account Id</th>
        <th>Account Name</th>
        <th>Account Contact Name</th>
      </thead>
      <tbody>
        <tr *ngFor="let recipient of emptyContactList.emptyDataRow">
          <td>{{ recipient.rowIndex }}</td>
          <td>{{ recipient.customerId }}</td>
          <td>{{ recipient.customerName }}</td>
          <td>{{ recipient.customerContactName }}</td>
        </tr>
      </tbody>
    </table>
    <div class="emptyDialogCloseDiv">
      <button color="primary" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="closeEmptyAlertDialog()">
        Ok
      </button>
    </div>

  </div>
</ng-template>